/** Main WL auth token key (not login-as `clientToken`). */
export const SESSION_TOKEN_KEY = 'token';

/**
 * Read the consultant/user session token from sessionStorage.
 * One-time migration from legacy localStorage so browser reopen cannot revive it.
 */
export function readSessionToken(): string | null {
  try {
    const existing = sessionStorage.getItem(SESSION_TOKEN_KEY);
    if (existing) return existing;

    const legacy = localStorage.getItem(SESSION_TOKEN_KEY);
    if (legacy) {
      sessionStorage.setItem(SESSION_TOKEN_KEY, legacy);
      localStorage.removeItem(SESSION_TOKEN_KEY);
      return legacy;
    }
    return null;
  } catch {
    return null;
  }
}

/** Persist main token in sessionStorage only; always strip durable localStorage copy. */
export function writeSessionToken(token: string | null | undefined): void {
  try {
    if (token) {
      sessionStorage.setItem(SESSION_TOKEN_KEY, token);
    } else {
      sessionStorage.removeItem(SESSION_TOKEN_KEY);
    }
    localStorage.removeItem(SESSION_TOKEN_KEY);
  } catch {
    // private mode / blocked storage
  }
}

export function hasClientImpersonationToken(): boolean {
  try {
    const clientToken = sessionStorage.getItem('clientToken');
    return Boolean(clientToken && clientToken.length > 0);
  } catch {
    return false;
  }
}
